import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ c("path", { d: "M11.026 15.386H4.964c-.724 0-1.324-.581-1.324-1.296V3.063c0-.714.59-1.296 1.324-1.296H6.07v-.152c0-.553.457-1 1.02-1h1.82c.562 0 1.02.447 1.02 1v.152h1.105c.724 0 1.325.582 1.325 1.296V14.09c0 .715-.591 1.296-1.325 1.296h-.01Zm-5.957-1.43h5.852V3.196H8.5V2.045h-1v1.153H5.07v10.76Z" }, null, -1), r = [
  n
];
function h(s, d) {
  return e(), t("svg", o, [...r]);
}
const _ = { render: h };
export {
  _ as default,
  h as render
};
